import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { startImpersonation, startSession } from 'app/modules/session/actions';
import { ImpersonationSuccessResponse } from 'app/modules/impersonation/responses';
import {
  clearRoutingHistory,
  setImpersonateId,
  setImpersonateLogId,
} from 'app/shared/utils/sessionStorage';
import routes from 'app/shared/utils/routes';
import { history } from 'app/store/browserHistory';
import { queryClient } from 'app/cache/queryClient';
import { AuthClient } from 'app/modules/session/models';
import { StartImpersonationPayload } from 'app/modules/impersonation/requests';
import { post, setPreSwitchTimestamp } from 'app/shared/utils/fetchr';
import { sendErrorToast } from 'app/shared/toasts/actions';

export const useStartImpersonation = (
  authClient: AuthClient,
  onSuccessStart: () => void,
) => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: async (payload: StartImpersonationPayload) => {
      return post<ImpersonationSuccessResponse>(
        '/v1/agents/log-impersonation-start',
        payload,
      );
    },
    onSuccess: async (result, payload) => {
      await queryClient.cancelQueries();
      onSuccessStart();
      setPreSwitchTimestamp();
      // Set impersonation session data
      setImpersonateId(payload.agent_to_impersonate_id);
      setImpersonateLogId(result.impersonation_log_id);

      // Reset app state
      clearRoutingHistory();
      dispatch({ type: '@@rootReducer/RESET_APP' });
      dispatch(startSession(authClient));

      dispatch(startImpersonation());
      history.push(routes.lumos.home);
      queryClient.clear();
    },
    onError: () => {
      dispatch(
        sendErrorToast('Failed to start impersonation. Please try again.'),
      );
    },
  });
};
